var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout-padding" },
    [
      _vm.test_status == "not_started"
        ? _c("div", { staticClass: "row justify-end" }, [
            _vm.test.type_activity == "test"
              ? _c("div", { staticClass: "col-12" }, [
                  _c("p", { staticClass: "q-title" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("test_type") + ": " + _vm.$t(_vm.test.type_slug)
                      )
                    )
                  ])
                ])
              : _vm._e(),
            _vm.test.type_activity == "quiz"
              ? _c("div", { staticClass: "col-12" }, [
                  _c("p", { staticClass: "q-title" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("quiz_type") + ": " + _vm.$t(_vm.test.type_slug)
                      )
                    )
                  ])
                ])
              : _vm._e(),
            _vm.test.type_activity == "test"
              ? _c("div", { staticClass: "col-12" }, [
                  _c("p", [
                    _vm._v(_vm._s(_vm.$t("description_" + _vm.test.type_slug)))
                  ]),
                  _c("p", [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("test_you_need_to_score")) +
                        "\n                "
                    ),
                    _c("strong", [_vm._v(_vm._s(_vm.test.minimum_score))]),
                    _vm._v(" " + _vm._s(_vm.$t("of")) + "\n                "),
                    _c("strong", [_vm._v(_vm._s(_vm.test.qty_questions))]),
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t("test_questions_to_be_approved_in_this_test")
                        ) +
                        "\n            "
                    )
                  ]),
                  _vm.test.type_slug == "block_test" ||
                  _vm.test.type_slug == "restart_test"
                    ? _c("p", [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t("test_you_have_tried")) +
                            "\n                "
                        ),
                        _c("strong", [_vm._v(_vm._s(_vm.test.qty_attempted))]),
                        _vm._v(
                          " " + _vm._s(_vm.$t("of")) + "\n                "
                        ),
                        _c("strong", [
                          _vm._v(_vm._s(_vm.test.maximum_attempts))
                        ]),
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$t("test_possible_tries")) +
                            "\n            "
                        )
                      ])
                    : _vm._e()
                ])
              : _vm._e(),
            _vm.test.type_activity == "quiz"
              ? _c("div", { staticClass: "col-12" }, [
                  _vm.test.type_slug == "evaluated_quiz"
                    ? _c("p", [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$t("description_" + _vm.test.type_slug)
                            ) +
                            " "
                        ),
                        _c("strong", [_vm._v(_vm._s(_vm.test.minimum_score))]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("description_2_" + _vm.test.type_slug)
                            ) +
                            "\n            "
                        )
                      ])
                    : _vm._e(),
                  _vm.test.type_slug == "unevaluated_quiz"
                    ? _c("p", [
                        _vm._v(
                          _vm._s(_vm.$t("description_" + _vm.test.type_slug))
                        )
                      ])
                    : _vm._e()
                ])
              : _vm._e(),
            _vm.showDanger()
              ? _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c(
                      "q-alert",
                      { attrs: { color: "negative", icon: "fal fa-ban" } },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(
                              _vm.$t("test_start_danger_" + _vm.test.type_slug)
                            ) +
                            "\n            "
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.realizations.length > 0
              ? _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c(
                      "q-list",
                      { attrs: { dense: "" } },
                      [
                        _c(
                          "q-collapsible",
                          {
                            attrs: {
                              icon: "fal fa-pen",
                              label: _vm.$t("previous_results")
                            }
                          },
                          [
                            _c("q-table", {
                              ref: "table_realizations",
                              staticClass: "shadow-0",
                              attrs: {
                                pagination: _vm.server_pagination,
                                data: _vm.realizations,
                                columns: _vm.columns,
                                "row-key": "id",
                                "no-data-label": _vm.$t("no_data_avaliable"),
                                "no-results-label": _vm.$t("no_results_found"),
                                "loading-label": _vm.$t("loading_data"),
                                "rows-per-page-label": _vm.$t("items_per_page"),
                                "rows-per-page-options": [0],
                                "hide-bottom": ""
                              },
                              on: {
                                "update:pagination": function($event) {
                                  _vm.server_pagination = $event
                                }
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function(props) {
                                      return _c(
                                        "q-tr",
                                        { attrs: { props: props } },
                                        _vm._l(props.cols, function(col) {
                                          return _c(
                                            "q-th",
                                            {
                                              key: col.name,
                                              attrs: { props: props }
                                            },
                                            [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(_vm.$t(col.label)) +
                                                  "\n                            "
                                              )
                                            ]
                                          )
                                        }),
                                        1
                                      )
                                    }
                                  },
                                  {
                                    key: "body",
                                    fn: function(props) {
                                      return [
                                        _c(
                                          "q-tr",
                                          {
                                            attrs: { props: props },
                                            nativeOn: {
                                              click: function($event) {
                                                return _vm.showModalResult(
                                                  props.row
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c(
                                              "q-td",
                                              {
                                                key: "result_date",
                                                attrs: { props: props }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(
                                                      _vm.format(
                                                        props.row.result_date
                                                      )
                                                    ) +
                                                    "\n                                "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "q-td",
                                              {
                                                key: "percent",
                                                attrs: { props: props }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(
                                                      props.row.percent.toFixed(
                                                        2
                                                      )
                                                    ) +
                                                    "%\n                                "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "q-td",
                                              {
                                                key: "score",
                                                attrs: { props: props }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(
                                                      props.row.score.toFixed(2)
                                                    ) +
                                                    "\n                                "
                                                )
                                              ]
                                            ),
                                            _c(
                                              "q-td",
                                              {
                                                key: "status",
                                                attrs: { props: props }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    class: _vm.getResultClass(
                                                      props.row
                                                    )
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          _vm.getResult(
                                                            props.row
                                                          )
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2751176546
                              )
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-3 q-mt-md" },
              [
                _c("q-btn", {
                  staticClass: "full-width",
                  attrs: {
                    color: "secondary",
                    label: _vm.$t("start"),
                    icon: "fal fa-play",
                    disable:
                      _vm.test.allowed_to_answer &&
                      !_vm.test.is_blocked &&
                      _vm.test.percent_approved != 100
                        ? false
                        : true
                  },
                  on: {
                    click: function($event) {
                      return _vm.startTest()
                    }
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm.test_status == "started"
        ? _c(
            "div",
            { staticClass: "row gutter-sm justify-end question-list" },
            [
              _vm._l(_vm.questions, function(question, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "col-xs-12 col-sm-12" },
                  [
                    _c(
                      "span",
                      { class: _vm.getQuestionClass(index, question) },
                      [
                        _vm._v("\n                " + _vm._s(index + 1) + ") "),
                        _c("span", {
                          domProps: { innerHTML: _vm._s(question.title) }
                        })
                      ]
                    ),
                    _c(
                      "q-field",
                      { attrs: { error: question.error } },
                      [
                        _c("q-option-group", {
                          staticClass: "questions q-mt-xs",
                          attrs: {
                            type: "radio",
                            color: "secondary",
                            options: question.answers
                          },
                          on: {
                            input: function($event) {
                              question.error = false
                            }
                          },
                          model: {
                            value: question.answer,
                            callback: function($$v) {
                              _vm.$set(question, "answer", $$v)
                            },
                            expression: "question.answer"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-3" },
                [
                  _c("q-btn", {
                    staticClass: "full-width",
                    attrs: {
                      color: "secondary",
                      label: _vm.$t("answer"),
                      icon: "fal fa-save"
                    },
                    on: {
                      click: function($event) {
                        return _vm.finishTest()
                      }
                    }
                  })
                ],
                1
              )
            ],
            2
          )
        : _vm._e(),
      _vm.test_status == "finished"
        ? _c(
            "div",
            { staticClass: "row gutter-sm justify-end question-list" },
            [
              _vm.test.type_activity == "test"
                ? _c("div", { staticClass: "col-12" }, [
                    _c("p", { staticClass: "q-title" }, [
                      _vm._v(_vm._s(_vm.$t("test_finished")))
                    ]),
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("you_finished_the_test_and_your_result_is")
                        ) + ":\n                "
                      ),
                      _c("span", { class: _vm.getResultClass(_vm.result) }, [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.$t(_vm.getResult(_vm.result))))
                        ])
                      ])
                    ]),
                    _c("p", [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t("your_score_was") +
                              " " +
                              _vm.result.score +
                              " " +
                              _vm.$t("of") +
                              " " +
                              _vm.result.qty_questions +
                              ", " +
                              _vm.$t("a_total_of") +
                              " " +
                              _vm.result.percent.toFixed(0) +
                              "% " +
                              _vm.$t("of_right_answers") +
                              "."
                          ) +
                          "\n            "
                      )
                    ]),
                    _vm.result.maximum_attempts
                      ? _c("p", [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("this_was_your_attempt")) +
                              " "
                          ),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.result.qty_attempted))
                          ]),
                          _vm._v(" " + _vm._s(_vm.$t("of")) + " "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.result.maximum_attempts))
                          ]),
                          _vm._v(".\n            ")
                        ])
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm.test.type_activity == "quiz"
                ? _c("div", { staticClass: "col-12" }, [
                    _c("p", { staticClass: "q-title" }, [
                      _vm._v(_vm._s(_vm.$t("quiz_finished")))
                    ]),
                    _vm.test.type_slug == "evaluated_quiz"
                      ? _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("you_finished_the_quiz_and_your_result_is")
                            ) + ":\n                "
                          ),
                          _c(
                            "span",
                            { class: _vm.getResultClass(_vm.result) },
                            [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm.$t(_vm.getResult(_vm.result)))
                                )
                              ])
                            ]
                          )
                        ])
                      : _vm._e(),
                    _c("p", [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t("your_score_was") +
                              " " +
                              _vm.result.score +
                              " " +
                              _vm.$t("of") +
                              " " +
                              _vm.result.qty_questions +
                              ", " +
                              _vm.$t("a_total_of") +
                              " " +
                              _vm.result.percent.toFixed(0) +
                              "% " +
                              _vm.$t("of_right_answers") +
                              "."
                          ) +
                          "\n            "
                      )
                    ]),
                    _vm.result.maximum_attempts
                      ? _c("p", [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("this_was_your_attempt")) +
                              " "
                          ),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.result.qty_attempted))
                          ]),
                          _vm._v(" " + _vm._s(_vm.$t("of")) + " "),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.result.maximum_attempts))
                          ]),
                          _vm._v(".\n            ")
                        ])
                      : _vm._e()
                  ])
                : _vm._e(),
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-3" },
                [
                  _vm.show_try_again
                    ? _c("q-btn", {
                        staticClass: "full-width",
                        attrs: {
                          color: "secondary",
                          label: _vm.$t("try_again"),
                          icon: "fal fa-sync"
                        },
                        on: {
                          click: function($event) {
                            return _vm.tryAgain()
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-3" },
                [
                  _c("q-btn", {
                    staticClass: "full-width",
                    attrs: {
                      color: "tertiary",
                      label: _vm.$t("see_result"),
                      icon: "fal fa-eye"
                    },
                    on: {
                      click: function($event) {
                        return _vm.showModalResult(_vm.result)
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-3" },
                [
                  _c("q-btn", {
                    staticClass: "full-width",
                    attrs: {
                      color: "primary",
                      label: _vm.$t("close"),
                      icon: "fal fa-times"
                    },
                    on: {
                      click: function($event) {
                        return _vm.closeTest()
                      }
                    }
                  })
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "90vh"
            }
          },
          model: {
            value: _vm.show_modal,
            callback: function($$v) {
              _vm.show_modal = $$v
            },
            expression: "show_modal"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_modal = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("result")) +
                        ": " +
                        _vm._s(_vm.test.type_title) +
                        "\n                "
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c(
                  "div",
                  { staticClass: "row gutter-sm justify-end question-list" },
                  _vm._l(_vm.realization_questions, function(question, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "col-xs-12 col-sm-12" },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(index + 1) +
                            ") "
                        ),
                        _c("span", {
                          class: question.is_correct
                            ? "text-positive"
                            : "text-negative",
                          domProps: { innerHTML: _vm._s(question.title) }
                        }),
                        _c(
                          "q-field",
                          { attrs: { error: question.error } },
                          [
                            _c("q-option-group", {
                              staticClass: "questions q-mt-xs",
                              class: question.is_correct
                                ? "checkbox-hit"
                                : "checkbox-error",
                              attrs: {
                                type: "radio",
                                options: question.answers,
                                readonly: ""
                              },
                              on: {
                                input: function($event) {
                                  question.error = false
                                }
                              },
                              model: {
                                value: question.answer,
                                callback: function($$v) {
                                  _vm.$set(question, "answer", $$v)
                                },
                                expression: "question.answer"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  }),
                  0
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }